import {useLayout} from '../../../core'
import {useLocation} from 'react-router-dom'
import {PageTitle} from './PageTitle'

const PageTitleWrapper = () => {
  const {config} = useLayout()
  const location = useLocation()
  
  // Routes where breadcrumbs should be hidden
  const hideBreadcrumbsRoutes = [,
  ]
  
  // Check if current route should hide breadcrumbs
  const shouldHideBreadcrumbs = hideBreadcrumbsRoutes.some(route => 
    location.pathname === route
  )
  
  if (!config.app?.pageTitle?.display) {
    return null
  }

  return <PageTitle hideBreadcrumbs={shouldHideBreadcrumbs} />
}

export {PageTitleWrapper}
